import {LoadIndicator} from 'devextreme-react/load-indicator';
import classNames from 'classnames';
import styles from './styles.module.scss';

export const Spinner = () => (
  <div className={classNames(styles.wrapper, 'dx-theme-background-color')}>
    <LoadIndicator id={'large-indicator'} height={60} width={60} />
  </div>
);
